export enum Tema {
    TRANSPARENTE = 'transparente',
    CINZA = 'cinza'
}
